// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2zoMU","insightsList":"newBusinessInsightsMenu_insightsList__13uUx","active":"newBusinessInsightsMenu_active__hplJ7"};